import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * O cartão que segura login, cadastro e onboarding.
 *
 * É o `Card` do shadcn com o respiro de 28px que essas telas já tinham
 * (`--card-spacing`), na sombra de cartão do painel.
 */
export function CartaoEntrada({
  rotulo,
  titulo,
  descricao,
  children,
  className,
}: {
  rotulo: string;
  titulo: string;
  descricao?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Card
      className={cn(
        "w-full max-w-[380px] [--card-spacing:--spacing(7)] rounded-[18px] shadow-cartao ring-0",
        className,
      )}
    >
      <CardHeader className="gap-1">
        <p className="rotulo">{rotulo}</p>
        <CardTitle className="text-[26px] font-semibold tracking-[-0.02em]">{titulo}</CardTitle>
        {descricao ? <CardDescription className="text-[13px]">{descricao}</CardDescription> : null}
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
